/**
 * The care-planner agent, full-screen at its own subdomain.
 *
 * Providers, auth gate, login bounce, i18n, async-turn delivery and the route
 * table are the platform's AgentApp — one implementation for every agent, so
 * the wiring cannot drift app by app (it already had: five apps were not
 * following the signed-in user's language, six never mounted the session-event
 * subscriber their chat needs). What is this agent's own is what it passes.
 *
 * `routes` is the agent's declared depth (src/routes.tsx), mounted identically
 * here and by the platform's AgentFrame, so `/stays/{id}` is the same path on
 * both surfaces. `sessionScreen` is the door old conversation links come in
 * through; it resolves to a stay and redirects.
 */
import { AgentApp } from '@frontend/components/agentDetail/AgentApp'

import Home from './pages/Home'
import Session from './pages/Session'
import { routes } from './routes'

export default function App() {
  return <AgentApp home={<Home />} routes={routes} sessionScreen={<Session />} />
}
